import { connect } from 'react-redux';
import DaftarNilaiSiswa from '../../../views/Kurikulum/Ulangan/DaftarNilaiSiswa.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(DaftarNilaiSiswa);
